import { useEffect, useState } from "react";

const CONSENT_KEY = "risiwellness.analytics-consent";
const MEASUREMENT_ID = "G-9DX68ECZTH";

const loadAnalytics = () => {
  if (document.querySelector(`script[data-risi-ga="${MEASUREMENT_ID}"]`)) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", MEASUREMENT_ID, { anonymize_ip: true });
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  script.dataset.risiGa = MEASUREMENT_ID;
  document.head.appendChild(script);
};

export const AnalyticsConsent = () => {
  const [choice, setChoice] = useState(() => window.localStorage.getItem(CONSENT_KEY));

  useEffect(() => {
    if (choice === "accepted") loadAnalytics();
  }, [choice]);

  const save = (value) => {
    window.localStorage.setItem(CONSENT_KEY, value);
    setChoice(value);
  };

  if (choice) return null;
  return (
    <aside className="fixed inset-x-4 bottom-4 z-[60] mx-auto max-w-2xl rounded-2xl border border-border bg-background p-5 shadow-2xl" aria-label="Cookie preferences">
      <p className="text-sm leading-relaxed text-foreground">
        We use optional analytics cookies to understand how visitors use this website and improve it. They are only enabled if you choose “Accept analytics”. Read our <a className="underline" href="/legal/cookies">Cookie Policy</a>.
      </p>
      <div className="mt-4 flex flex-wrap gap-3">
        <button type="button" onClick={() => save("accepted")} className="rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground">Accept analytics</button>
        <button type="button" onClick={() => save("rejected")} className="rounded-full border border-border px-5 py-2.5 text-sm font-semibold text-foreground">Reject optional cookies</button>
      </div>
    </aside>
  );
};
